import React from "react";
import PDFTableRow from "components/PDF/Table/TableRow";
import { Text } from "@react-pdf/renderer";
import { formatMoney } from "infra/helpers/number";

interface PDFRelatorioCobrancaTotalRowProps {
  juros: number;
  multa: number;
  valorTaxaCobranca: number;
  total: number;
  valor: number;
  taxaMulta: number;
  taxaJuros: number;
  taxaCobranca: number;
  dataPagamento: string | null;
  honorarios: number;
  atualizacaoMonetaria: number;
  valorOriginal: number;
}

function TotalRow(data: PDFRelatorioCobrancaTotalRowProps) {
  return (
    <PDFTableRow
      backgroundColor={"white"}
      item={data}
      columns={[
        {
          title: "",
          flexGrow: 2.5,
        },
        {
          flexGrow: 1,
          title: "valorOriginal",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.valor)}
            </Text>
          ),
        },
        {
          title: "totalMulta",
          flexGrow: 0.8,
          textAlign: "right",
          render: (original) => <Text>{formatMoney(original.multa)}</Text>,
        },
        {
          flexGrow: 0.8,
          title: "totalJuros",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.juros)}
            </Text>
          ),
        },
        {
          flexGrow: 1.6,
          title: "totalTaxaCobranca",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.valorTaxaCobranca)}
            </Text>
          ),
        },
        {
          flexGrow: 1,
          title: "correcaoMonetaria",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.atualizacaoMonetaria)}
            </Text>
          ),
        },
        {
          flexGrow: 1,
          title: "total",
          render: (item) => (
            <Text style={{ marginLeft: "auto" }}>
              {formatMoney(item.total)}
            </Text>
          ),
        },
      ]}
    />
  );
}

export default TotalRow;
